import { useTranslation } from "src/hooks";
import { ChainSingleSelection } from "src/components/ChainSelection";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { FilterFieldsKeys } from "src/views/Ledger/LedgerBalanceMonitor/types/FilterFields";

interface IProps {
  value: string;
  onChange: (chainName: string) => void;
}

// currently will only support tron, not enable for selection
const ChainNameSingleSelection = ({ value, onChange }: IProps) => {
  const { translatePrefix } = usePageConfigProviderContext();

  const { t, tc } = useTranslation(translatePrefix);

  return (
    <ChainSingleSelection
      label={tc("phSelection", { fieldName: t(FilterFieldsKeys.ChainName) })}
      setChoice={onChange}
      choice={value}
    />
  );
};

export default ChainNameSingleSelection;
